<script>
export default {
  name: 'CompPage',
  props:['param','fun_reload','total'],
  data() {
    return {
      pageSize:100,
      pagerCount:5,
    }
  },
  methods: {
    fun_to_page(_n){
      this.param.pageNo=_n;
      this.fun_reload();
    },
    fun_on_load(){
      this.pageSize = +process.env.VUE_APP_PAGE_SIZE;
    },
  },
  mounted() {
    this.fun_on_load();
  },
}
</script>

<template>
  <div class="table_pagination" style="text-align: right;">
    <el-pagination background @current-change="fun_to_page" :pager-count="pagerCount" layout="total, prev, pager, next, jumper" :total="total" :page-size="pageSize"></el-pagination>
  </div>
</template>

<style scoped>

</style>
